import { NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';

import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './shared/material.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { SidebarComponent } from './layouts/main-layout/sidebar/sidebar.component';
import { HeaderComponent } from './layouts/main-layout/header/header.component';
import { BrandingComponent } from './layouts/main-layout/sidebar/branding.component';
import { AppNavItemComponent } from './layouts/main-layout/sidebar/nav-item/nav-item.component';
import { JwtInterceptor } from '@core';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_DATE_FORMATS } from './shared/pipes/date-format';
import { DatePipe } from '@angular/common';

import { HttpClient,HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { DialogPhimtatComponent } from './layouts/main-layout/header/dialog-phimtat/dialog-phimtat.component';

export function HttpLoaderFactory(http:HttpClient){
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    AuthLayoutComponent,
    SidebarComponent,
    HeaderComponent,
    BrandingComponent,
    AppNavItemComponent,
    DialogPhimtatComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    SharedModule,
    TablerIconsModule.pick(TablerIcons),
    HttpClientModule,
    TranslateModule.forRoot(
      {
      loader:{
        provide:TranslateLoader,
        useFactory:HttpLoaderFactory,
        deps:[HttpClient]
      }
    }
    ),
    InfiniteScrollModule,
    MatSelectInfiniteScrollModule,
  ],
  providers: [
    DatePipe,
    HttpClient,
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptors([JwtInterceptor])),
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
